import { range } from './value';

/**
 * Determine whether a character is valid for entry into a number field
 * @param {number} keyCode - The key (not ascii) code of the button being pressed
 * @param {bool} allowDecimal - TWhether or not decimal separators are allowed
 * @summary Allows numbers from the top row + number pad, as well as a few
 * 			special characters to aid navigation around and out of the field
 * @returns {bool} Whether the supplied key is valid for a numerical field
 */
export const isKeySuitableForNumberField = (keyCode, allowDecimal = false) => {
	const topDigits = range(48, 57);
	const numPadDigits = range(96, 105);

	let validKeyCodes = [
		...topDigits,
		...numPadDigits,
		8,  // backspace
		9, // tab
		35, // end
		36, // home
		46, // delete
		37, // left
		39 // right
	];

	if (allowDecimal){
		validKeyCodes = [
			...validKeyCodes,
			110, // numeric period
			188, // comma
			190 // period
		];
	}

	return validKeyCodes.includes(keyCode);
};



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/browser.js